import { Component } from 'react';

interface IProps {
    value?: number;
}

export class NumberAsCurrency extends Component<IProps, any> {

    render() {
        return (
            '€' + (Math.round(this.props.value!) ?? 0).toLocaleString('en-US', { useGrouping: true })
        );
    }
}
